var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11.2,
    viewBox: "0 0 14 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12755",
    "data-name": "Path 12755",
    d: "M12.6,11.2H1.4A1.4,1.4,0,0,1,0,9.8V1.339A1.4,1.4,0,0,1,1.4,0H12.6A1.4,1.4,0,0,1,14,1.4V9.8A1.4,1.4,0,0,1,12.6,11.2ZM1.4,2.708V9.8H12.6V2.708L7,6.44ZM1.96,1.4,7,4.76,12.04,1.4Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.74029019d1f38d34e70cc5f5ee90f9b4.svg";
export { ForwardRef as ReactComponent };